<template>
    <div class="attendance_group_wrap">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left"></div>
            <div class="page-filter_wrap_right">
                <el-button type="primary" @click="handleClickAdd">新增假期</el-button>
            </div>
        </div>
        <div class="page-content" v-loading="loading">
            <vxe-grid
                ref="stageTable"
                v-if="stageTableShow"
                v-bind="stageTableOptions"
                @row-dragend="stageTableRowDragendEvent"
            >
                <template #use_user="{ row }">
                    <span v-if="row.json_rule && row.json_rule.is_use_user_all == 1">全公司</span>
                    <span v-else>
                        {{
                            row.json_rule && row.json_rule.use_user && row.json_rule.use_user.user_department_list
                                ? getDepartmentName(row.json_rule.use_user.user_department_list)
                                : "--"
                        }}
                    </span>
                </template>
                <template #status="{ row }">
                    <span class="table-operate-icon">
                        <el-switch
                            v-model="row.status"
                            :active-value="1"
                            :inactive-value="0"
                            size="small"
                            :width="28"
                            @change="handleStatusChange(row)"
                        >
                        </el-switch>
                        <span>{{ row.status == 1 ? "已启用" : "已禁用" }}</span>
                    </span>
                </template>
                <template #action="{ row }">
                    <div class="table-operate-icon">
                        <el-tooltip effect="dark" content="编辑" placement="top"
                            ><i class="iconfont icon-bianji" @click="handleClickEdit(row)"></i
                        ></el-tooltip>
                    </div>
                </template>
            </vxe-grid>
        </div>
        <AttendanceHolidayTpl
            :holidayTplDialogVisible.sync="holidayTplDialogVisible"
            :editId="editId"
            @callbackSuccess="getTableData"
            v-if="holidayTplDialogVisible"
        />
    </div>
</template>

<script>
import {
    GetDepartmentList,
    GetHolidayRuleList,
    DeleteHolidayRule,
    UpdateHolidayRuleStatus,
    UpdateHolidayRuleSort,
} from "@/api";
import AttendanceHolidayTpl from "./component/attendance_holiday_tpl.vue";
export default {
    name: "AttendanceHolidayRule",
    components: { AttendanceHolidayTpl },
    data() {
        return {
            loading: false,
            stageTableShow: true,
            stageTableOptions: {
                border: true,
                rowConfig: {
                    useKey: true,
                    drag: true,
                },
                columnConfig: {
                    resizable: true,
                    useKey: true,
                },
                rowDragConfig: {
                    icon: "iconfont icon-a-move",
                    visibleMethod({ row }) {
                        if (row.is_system === 1) {
                            return false;
                        }
                        return true;
                    },
                },
                seqConfig: {
                    seqMethod({ rowIndex }) {
                        return "";
                    },
                },
                columns: [
                    { type: "seq", title: "展示顺序", width: 80, dragSort: true },
                    { field: "name", title: "假期名称", width: 320 },
                    { field: "time_unit_text", title: "时长单位", minWidth: 160, showOverflow: true },
                    {
                        field: "use_user",
                        title: "适用人员范围",
                        minWidth: 290,
                        showOverflow: true,
                        slots: { default: "use_user" },
                    },
                    { field: "balance_rule_text", title: "余额规则", width: 238 },
                    { field: "status", title: "状态", width: 102, slots: { default: "status" } },
                    { title: "操作", width: 52, slots: { default: "action" } },
                ],
                data: [],
            },
            holidayTplDialogVisible: false,
            editId: "",
            depOptions: [], // 部门数据
        };
    },
    async created() {
        await this.getDepartmentList();
        await this.getTableData();
    },
    methods: {
        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.depOptions = this.treeToArray(res.data || []);
                }
            });
        },
        // 将树形结构转换为一维数组结构
        treeToArray(tree, arr = []) {
            for (const node of tree) {
                arr.push(node);
                if (node.children && node.children.length) {
                    this.treeToArray(node.children, arr);
                }
            }
            return arr;
        },
        // 获取部门人员
        getDepartmentName(ids) {
            let list = [];
            ids.forEach((relate_id) => {
                if (relate_id) {
                    const nodeItem = this.depOptions.find(item=> item.relate_id == relate_id)
                    nodeItem ? list.push(nodeItem.relate_name) : ''
                }
            });
            return list.join('、')
        },
        // 新增假期
        handleClickAdd() {
            this.editId = "";
            this.holidayTplDialogVisible = true;
        },
        // 编辑
        handleClickEdit(row) {
            this.editId = row.id;
            this.holidayTplDialogVisible = true;
        },
        // 排序拖拽结束事件
        stageTableRowDragendEvent() {
            const sort_data = this.$refs.stageTable.getFullData().map((item, index) => {
                return {
                    id: item.id,
                    sort: item.sort,
                };
            });
            let data = JSON.parse(JSON.stringify(sort_data));
            const minSort = Math.min(...sort_data.map((obj) => obj.sort));
            data.forEach((item, index) => {
                item.sort = minSort + index;
            });
            UpdateHolidayRuleSort({ sort_data: data }).then((res) => {
                if (res.code === 200) {
                    this.$message({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.getTableData();
                        },
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleStatusChange(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: `${row.status == 0 ? "停用" : "启用"}假期规则`,
                message: h("div", null, [
                    h(
                        "span",
                        null,
                        `确定要${row.status == 0 ? "停用" : "启用"}假期规则吗？审批中的请假类型也一并停用！`
                    ),
                ]),
                iconClass: "icon-jinggao iconfont prompt_message_icon status1",
                customClass: "prompt_message_custom attendance_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    UpdateHolidayRuleStatus({ id: row.id, status: row.status }).then((res) => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.getTableData();
                                },
                            });
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {
                    row.status = row.status == 0 ? 1 : 0;
                });
        },
        // 获取列表
        getTableData() {
            this.loading = true;
            GetHolidayRuleList({
                status: [0, 1],
            }).then((res) => {
                if (res.code === 200) {
                    let data = res.data;
                    data.forEach((item) => {
                        this.$set(
                            item,
                            "time_unit_text",
                            item.time_unit == "day" ? "天" : item.time_unit == "ampm" ? "半天" : "小时"
                        );
                        this.$set(item, "balance_rule_text", item.balance_rule == 1 ? "限额" : "不限额");
                    });
                    this.stageTableOptions.data = data || [];
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.attendance_group_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .page-filter_wrap {
        padding: 16px 16px 0;
    }
    .page-content {
        flex: 1;
        padding: 16px;
        ::v-deep {
            .table-operate-icon {
                .el-switch__core {
                    height: 18px;
                    &::after {
                        width: 12px;
                        height: 12px;
                        top: 2px;
                    }
                }
                .el-switch {
                    line-height: 18px;
                    margin-right: 8px;
                    &.is-checked {
                        .el-switch__core {
                            &::after {
                                margin-left: -14px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
